import { render, staticRenderFns } from "./LiveQuizPlayer.vue?vue&type=template&id=79f7d8a4&scoped=true"
import script from "./LiveQuizPlayer.vue?vue&type=script&lang=js"
export * from "./LiveQuizPlayer.vue?vue&type=script&lang=js"
import style0 from "./LiveQuizPlayer.vue?vue&type=style&index=0&id=79f7d8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f7d8a4",
  null
  
)

export default component.exports